import { render, staticRenderFns } from "./Indemnizaciones.vue?vue&type=template&id=033b1cde&"
import script from "./Indemnizaciones.vue?vue&type=script&lang=js&"
export * from "./Indemnizaciones.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Indemnizaciones.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports